@if(displaySimilarContent()){
<div class="similar-content-container z-2 w-full" data-testid="player_similar-content"
    [ngClass]="{ 'translated': isUiHidden(),'mini-player-similar-content': isMiniPlayer()}">
    <div class="similar-content-header relative flex justify-center items-center"
        [ngClass]="{'mini-similar-content-header': isMiniPlayer()}">
        <span class="font-bold"
            [ngClass]="{'mini-similar-content-title': isMiniPlayer()}">{{'settings.streaming.binge_overlay'| transloco}}</span>
        <!-- Close the carousel — pinned to the far right of the carousel width -->
        <rounded-icon-button [size]="isMiniPlayer() ? 'xxsmall' : 'small'" class="similar-content-close"
            data-testid="player_similar-content_close" (onClick)="closeSimilarContent()"
            [imgSrc]="skinning.getImage('icon_close')" [ngClass]="{'mini-similar-content-close': isMiniPlayer()}">
        </rounded-icon-button>
    </div>

    <!-- Equal-width tiles that stretch to fill the carousel width; 1.5rem (gap-6) gutter.
         Capped at a third of the row (see .similar-content-tile) so a short list — a single
         binge item above all — centres instead of one card growing past the viewport. -->
    <div class="flex w-full justify-center gap-6" [ngClass]="{'mini-similar-content-row': isMiniPlayer()}">
        @for (item of similarContent(); track item.referenceId) {
        <div class="similar-content-tile flex-1 min-w-0" data-testid="player_similar-content_tile">
            <div class="card relative w-full aspect-[16/9] rounded-lg overflow-hidden cursor-pointer"
                [alwaysReload]="true" [transcodeImage]="item.posterLandscape">
                @if (!item.hideTitle) {
                <div class="shadow"></div>
                }
                <!-- Play button — centered in the middle of the tile -->
                <div class="absolute inset-0 flex items-center justify-center">
                    <rounded-icon-button [size]="isMiniPlayer() ? 'xxsmall' : 'small'"
                        (onClick)="playSimilarContent(item)"
                        [imgSrc]="skinning.getImage('icon_play')"></rounded-icon-button>
                </div>
                @if (!item.hideTitle) {
                <span class="card-title"
                    [ngClass]="{'mini-similar-content-card-title': isMiniPlayer()}">{{item.title}}</span>
                }
            </div>
        </div>
        }
    </div>
</div>
}
